import type { YeetAgentPromptDocument } from "contracts/prompts/yeet-agent-document";

/** The single-line text fragments of the yeet-agent prompt, each with a
 * plain-language label and hint so a non-technical editor knows what it
 * controls. `steps` is edited separately as an ordered list. */
type TextFragmentKey = Exclude<keyof YeetAgentPromptDocument, "steps">;

export const TEXT_FRAGMENTS: {
  key: TextFragmentKey;
  label: string;
  hint: string;
}[] = [
  {
    key: "persona",
    label: "Persona",
    hint: "Who the agent is and the mindset it brings to the audit.",
  },
  {
    key: "interconnected",
    label: "How the page fits together",
    hint: "Reminds the agent that content, design and trust signals reinforce each other.",
  },
  {
    key: "protocolIntro",
    label: "Protocol intro",
    hint: "Sets up the mandatory sequence of steps that follows.",
  },
  {
    key: "investigateMultimodal",
    label: "Investigate — with screenshots",
    hint: "Used when the model can see images: how to inspect the page visually.",
  },
  {
    key: "investigateTextOnly",
    label: "Investigate — text only",
    hint: "Used when the model can't see images: how to inspect from the content alone.",
  },
  {
    key: "toolErrorsNote",
    label: "Handling tool errors",
    hint: "What the agent should do when a tool call fails.",
  },
];
